import * as React from 'react';

import * as styles from './Paragraph.scss';

interface OwnProps {
  children: React.ReactNode;
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'pre';
}

export function Paragraph({element: Element = 'p', children}: OwnProps) {
  return <Element className={styles.Paragraph}>{children}</Element>;
}
